<div class="patient">

        <div class="wrapper">
    
        <!-- ========================== header (start) ========================== -->
        <header class="l-header">
    
            <div class="on-mobile header-logo">
                <img src="assets/icons/logo.svg" alt="Artisan Sonics"/>
            </div>
            <div class="l-header-panel" [ngClass]="loginService.isCardio && isReports ? 'space' :''" [ngClass]="loginService.isAdmin && !loginService.isCardio && !loginService.isGastro ? 'dsp-flex' :''">
                <div style="display: flex;align-items: center;">

                    <h1 class="t-title-main">
                        {{AWLlist? 'TodayList': (examList? 'Exams':'Patients')}} 
                    </h1>
                    <div class="l-flex l-flex-c t-field t-field-pad"  *ngIf="AWLlist" style='margin-left: 2em'>

                        <label>
                            Status 
                        </label>

                        <i class="t-sep"></i>
                    
                        <select class="t-field t-select" [(ngModel)]="AWLStatus" (change)="AWL();startdate=null;enddate=null">
                            <option value="All">All</option>
                            <option value="Waiting" *ngIf="loginService.isCardio">Scheduled</option>
                            <option [value]="loginService.isCardio ? 'Received' : 'Waiting'">Waiting</option>
                            <option value="In Progress">In Progress</option>
                            <option value="Completed" *ngIf="! loginService.isCardio">Completed</option>
                            <option value="Completed" *ngIf="loginService.isCardio">Waiting for Interpretation</option>
                            <option value="Interpreted" *ngIf="loginService.isCardio">Interpreted</option>
                        </select>
                  
                    </div>
                </div>
                <span *ngIf="AWLlist && loginService.isCardio && AWLStatus == 'Completed'" style='margin-left: 1em'>
                    Exam Type
                    <select class="t-field t-select" [(ngModel)]="AWLExam" (change)="AWL()">
                        <option value="All">All</option>
                        <option *ngFor="let name of getTodayListExamTypes()" [value]="name">{{name}}</option>
                    </select>
                </span>
                <span *ngIf="AWLlist && loginService.isCardio && AWLStatus == 'Completed'" style='margin-left: 1em' (dblclick)="startdate = null;enddate=null;AWL()">
                    From  <input [matDatepicker]="startDatepicker"  [(ngModel)]="startdate" [max]="enddate" class="t-field t-field--date menstural-field" aria-labelledby="menstural_LMP" (click)="startDatepicker.open()" (ngModelChange)="AWL()">
                    <mat-datepicker #startDatepicker></mat-datepicker>
                    Until
                    <input [matDatepicker]="endDatepicker"  [(ngModel)]="enddate" [min]="startdate" (click)="endDatepicker.open()" class="t-field t-field--date menstural-field" aria-labelledby="menstural_LMP" (ngModelChange)="AWL()">
                    <mat-datepicker #endDatepicker></mat-datepicker>
                </span>
                <ng-container *ngIf="! loginService.hasPremission('NoExams')">
                <span *ngIf="loginService.isCardio && !(loginService.hasPremission('Pneumology')) && isReports && (examList && examList.length >0)" >TTE Adults: {{examList ? filterExams(examList, 'TTE Adults').length : 0}}</span>
                <span *ngIf="loginService.isCardio && (loginService.hasPremission('Pneumology')) && isReports && (examList && examList.length >0)" >Pulmonary functional assessment: {{examList ?  filterExams(examList, 'Pulmonary functional assessment').length  : 0}}</span>
                <span *ngIf="loginService.isCardio && !(loginService.hasPremission('Pneumology')) && isReports && (examList && examList.length >0)" >TTE Pediatric: {{examList ? filterExams(examList, 'TTE Pediatric').length : 0}}</span>
                <span *ngIf="loginService.isCardio && !(loginService.hasPremission('Pneumology')) && isReports && (examList && examList.length >0)" >Stress: {{examList ?  filterExams(examList, 'Stress').length  : 0}}</span>
                <span *ngIf="loginService.isCardio && !(loginService.hasPremission('Pneumology')) && isReports && (examList && examList.length >0)" >Stress-Echo: {{examList ?  filterExams(examList, 'Stress-Echo').length  : 0}}</span>
                <span *ngIf="loginService.isCardio && !(loginService.hasPremission('Pneumology')) && isReports && (examList && examList.length >0)" >Holter ECG: {{examList ?  filterExams(examList, 'Holter ECG').length  : 0}}</span>
                <span *ngIf="loginService.isCardio && (loginService.hasPremission('Pneumology')) && isReports && (examList && examList.length >0)" >Methacholine test: {{examList ?  filterExams(examList, 'Methacholine test').length  : 0}}</span>

                <span *ngIf="loginService.isCardio && isReports && !(loginService.hasPremission('Pneumology')) && (examList && examList.length >0)" >Duplex Carotid: {{examList ?  filterExams(examList, 'Duplex Carotid').length  : 0}}</span>
                </ng-container>
                <span *ngIf="loginService.isCardio && isReports && (examList && examList.length >0)" >Number Of Exams: {{examList ? examList.length : 0}}</span>
                <div style="display: inline-flex;" *ngIf="loginService.isCardio && isReports && showExcel">
                    <button (click)="sendMacabi()" class="search-btn search-btn--newPatient" *ngIf="! sentMacabi && ((reportName == 'Macabi' && fromd['_i'] && tod['_i'] && fromd['_i'].year == tod['_i'].year && fromd['_i'].month == tod['_i'].month) || (reportName == 'Macabifin' && ! macabiMissing))">Send to Macabi</button>
                    
                    <ng-container *ngIf="reportName == 'HMO' && hmostype== 'IDF' && fromd['_i'] && tod['_i'] && fromd['_i'].year == tod['_i'].year && fromd['_i'].month == tod['_i'].month">
                        <!-- the xlsx file carries the clinic's invoice number for the month -->
                        <input *ngIf="idfFormat == 'xlsx'" class="t-field" [(ngModel)]="idfInvoice" placeholder="מס. חשבונית" style="width: 8em; padding-left: 0.5em; margin-right: 0.5em">
                        <button (click)="getIDF()" class="search-btn search-btn--newPatient" [disabled]="idfFormat == 'xlsx' && ! idfInvoice.trim()" style="padding-left: 1em; padding-right: 1em">Download IDF file</button>
                    </ng-container>
                    <span (click)="export()" class="header-menu-link icon-file"
                    aria-label="Export" matTooltip="Export to Excel" *ngIf="examList && examList.length > 0 && (! macabiMissing || reportName != 'Macabifin')"></span>

                    <span (click)="showprintopts=true;showprint=true" class="header-menu-link icon-print"
                    aria-label="Print" matTooltip="Print" *ngIf="reportName != 'Macabifin'"></span>
                </div>
                <!-- Maccabi unit for the card and W/O card checks, when the clinic has more than one -->
                <select class="t-field t-select" *ngIf="AWLlist && loginService.isCardio && loginService.macabiUnits?.length > 1" [ngModel]="loginService.macabiUnit" (ngModelChange)="loginService.macabiUnit = $event" matTooltip="יחידת מכבי" style='margin-left: auto; width: auto; margin-right: 0.5em;'>
                    <option *ngFor="let u of loginService.macabiUnits" [value]="u.code">{{u.desc}}</option>
                </select>
                <button class="search-btn search-btn--newPatient" *ngIf="AWLlist && loginService.isCardio && ! swiping" [style.margin-left]="loginService.macabiUnits?.length > 1 ? '0' : 'auto'" style='width: 8em; margin-right: 0.5em;' (click)="swiping=true;getcard()">הצג כרטיס מגנטי</button>
                <button class="search-btn search-btn--newPatient" *ngIf="AWLlist && loginService.barcodeScan && ! swiping" style='margin-left: auto; width: 8em' (click)="swiping=true;getcard()">Scan barcode</button>
                <input *ngIf="AWLlist && loginService.isCardio && swiping" #swipeField (keyup)="proccesscard($event)" [(ngModel)]="card">
                <input *ngIf="AWLlist && loginService.barcodeScan && swiping" #swipeField (keyup)="barscan($event)" [(ngModel)]="card">
                <nav class="on-mobile header-mobilePanel">
                    <button class="btn-mobileMenu" id="open-mainNav" data-show=".l-sidebar" aria-label="open mobile sidebar"></button>
                </nav>	
                <div *ngIf="(loginService.isAdmin || loginService.userType == 'secretary') && (loginService.separatedClinic || loginService.SeparateZimun) && (!loginService.isGastro && !loginService.isCardio && !loginService.ishospital)" style="position:absolute; right: 4em">

                    <div class="l-flex l-flex-c t-field t-field-pad" >

                        <label matTooltip="שם הרופא">
                            <img src="../../assets/icons/drb.svg">
                        </label>

                        <i class="t-sep"></i>

                        <span class="t-validation-wrap l-fg1">
                            <select [(ngModel)]="loginService.doctor" (ngModelChange)="AWL()" class="t-select w100" style="text-align: center;">
                                <option [value]="null">All</option>
                                <!-- <option *ngIf="awlExam && ! examTypes.includes(awlExam)" [value]="awlExam">{{awlExam}}</option> -->
                                <ng-container *ngFor="let e of getDoctors()">
                                    <option [value]="e.UID">{{e.Name}}</option>
                                </ng-container>
                            </select>
                        </span>
                        
                    </div>		
                
                </div>
                <!-- ======= Appointment Rooms Filter (Start) ======= -->
                @if (AWLlist && loginService.rooms && loginService.rooms.length) {
                    <div style="right: 10em">
                        <div class="l-flex l-flex-c t-field t-field-pad">
                          <label matTooltip="שם החדר">
                            <img src="../../assets/icons/room-blue.svg" />
                          </label>

                          <i class="t-sep"></i>

                          <span class="t-validation-wrap l-fg1">
                            <select
                              [(ngModel)]="loginService.room"
                              class="t-select w100"
                              style="text-align: center"
                              (ngModelChange)="AWL()"
                            >
                              <option [ngValue]="null">All</option>
                              @for (room of loginService.rooms; track room.AutoIndex) {
                                <option [value]="room.AutoIndex">{{ room.RoomName }}</option>
                              }
                            </select>
                          </span>
                        </div>
                    </div>
                }
                <!-- ======= Appointment Rooms Filter (End) ======= -->
                
            </div>
        
        </header>
        <!-- ========================== header (end) ========================== -->
    
    
        <!-- ========================== intro (start) ========================== -->
    
        <main class="l-deashboard">

            @if (searchLoading) {
            <div class="list-spinner-wrap" [class.is-leaving]="searchFading">
                <img src="../../assets/images/Wedges.svg" alt="Loading..." class="list-spinner-img" />
            </div>
            } @else {
                @if (isAWL && AWLlist && AWLlist.length === 0) {
                    @if (AWLStatus && AWLStatus != 'All') {
                    <p style="padding: 2rem; text-align: center;">{{ 'GUI.Patients.empty.today status' | translate:{ status: ('GUI.Patients.todaylist.statues.' + ((loginService.isCardio && AWLStatus == 'Completed') ? 'Waiting for Interpretation' : AWLStatus) | translate) } }}</p>
                    } @else {
                    <p style="padding: 2rem; text-align: center;">{{ 'GUI.Patients.empty.today' | translate }}</p>
                    }
                }
                <div class="l-flex patient-item" *ngFor="let pat of AWLlist;index as i"
                     [ngStyle]="(pat.HMOExamCode || pat.HMOExamCode2) ? {'height': 'auto', 'min-height': 'fit-content'} : {}">

                    <div class="w100 patient-item-link">
        
                        <div class="l-table h100">
                            <span class="l-td-m patient-item-cell patient-id"  (click)="setAWL(pat);selectedPatient=pat">
                                Time: <strong>{{loginService.isCardio && AWLStatus == "Completed"? (pat.ExamDate | date: 'd/M/yy, h:mm a'):(pat.ExamDate | date: 'shortTime')}}</strong>
                            </span>
                            <span class="l-td-m patient-item-cell patient-id" (click)="setAWL(pat);selectedPatient=pat" >
                                ID: <strong>{{pat.ID}}</strong>
                            </span> 
                            <span class="l-td-m patient-item-cell patient-name-first" [ngClass]="pat.Reason ?  'type-v': 'type-plus'" (click)="setAWL(pat);selectedPatient=pat">
                                {{pat.First}} {{pat.Last}}
                                <span class="anatomy-show-more" style="bottom: auto;right:auto" *ngIf="(! loginService.ishospital || loginService.ishospital == 'belinson') && !loginService.isGastro"> <!--form elemnts not working when empty so using hack-->
                                    
                                    <div class="on-hoverPanel">
                                        
                                        <div class="on-hoverPanel-body">
                    
                                            <div class="anatomy-item-details">
                                                
                                                <div class="anatomy-items-desc">
                    
                                                    <div class="anatomy-items-edited scroller mCustomScrollbar _mCS_2 mCS_no_scrollbar" contenteditable="true"><div id="mCSB_2" class="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside" tabindex="0" style="max-height: none;"><div id="mCSB_2_container" class="mCSB_container mCS_y_hidden mCS_no_scrollbar_y" style="position:relative; top:0; left:0;" dir="ltr">   </div>
                                                    <div id="mCSB_2_scrollbar_vertical" class="mCSB_scrollTools mCSB_2_scrollbar mCS-light mCSB_scrollTools_vertical" style="display: none;"><div class="mCSB_draggerContainer"><div id="mCSB_2_dragger_vertical" class="mCSB_dragger" style="position: absolute; min-height: 30px; top: 0px; display: block; height: 12px; max-height: 106.938px;"><div class="mCSB_dragger_bar" style="line-height: 30px;"></div></div><div class="mCSB_draggerRail"></div></div></div></div></div>
                                                    <textarea class="anatomy-items-edit" (click)="$event.stopPropagation()" (change)="saveComment(pat.Reason,pat.AWLID)" [(ngModel)]="pat.Reason"></textarea>
                                                    
                    
                                                </div>
                    
                                            </div>
                    
                                           <!--<button class="anatomy-details-save">Save Comments</button> -->
                    
                                        </div>
                    
                                    </div>
                    
                                </span>
                            </span> 
                            <span class="l-td-m patient-item-cell patient-name-first" *ngIf="loginService.ishospital" (click)="setAWL(pat);selectedPatient=pat">
                                <ng-container *ngIf="pat.Locked">Open By: {{pat.LockedBy}} at {{pat.Locked | date: 'shortTime'}}</ng-container> 
                            </span>
                            <span class="l-td-m patient-item-cell patient-name-last" *ngIf="loginService.ishospital && ! loginService.AWLExamNames" (click)="setAWL(pat);selectedPatient=pat">
                                Address: {{pat.Address}} {{pat.City}}
                            </span>
                            <span class="l-td-m patient-item-cell patient-name-first" *ngIf="! loginService.ishospital" (click)="setAWL(pat);selectedPatient=pat">
                                Phone: {{pat.Phone ? pat.Phone : pat.Mobile}}
                            </span>
                            <span class="l-td-m patient-item-cell patient-name-first" *ngIf="(! loginService.ishospital || loginService.AWLExamNames) && pat.ExamCode">
                                {{pat.ExamCode}}
                                <span *ngIf="loginService.hasPremission('Questionnaires')" style="position: relative; display: inline-block;">
                                <img src="../../assets/icons/message.svg"
                                     style="height: 1.2em; cursor: pointer; vertical-align: middle; margin: 0 0.4em"
                                     matTooltip="Send Questionnaire"
                                     (click)="$event.stopPropagation(); openSendQuestionnaire(pat)" />
                                <span *ngIf="patQuestionnaireAnswered[pat.AWLID]" style="position: absolute; bottom: -0.1em; right: -0.4em; font-size: 0.75em; color: green; font-weight: bold; background: white; border-radius: 50%; line-height: 1; padding: 0 1px;">✓</span>
                                </span>
                <ng-container *ngIf="pat.HMOExamCode">
                  <span ><strong>קוד טיפול:</strong> {{ pat.HMOExamCode }}<span *ngIf="pat.HMOExamName"> - {{ pat.HMOExamName }}</span></span>
                </ng-container>
                <ng-container *ngIf="pat.HMOExamCode2">
                  <br><span ><strong>קוד טיפול 2:</strong> {{ pat.HMOExamCode2 }}<span *ngIf="pat.HMOExamName2"> - {{ pat.HMOExamName2 }}</span></span>
                </ng-container>
                            </span>
                            <span class="l-td-m patient-item-cell patient-name-first" *ngIf="(! loginService.ishospital || loginService.AWLExamNames) && (! pat.ExamCode && loginService.isCardio)">
                               
                                <select class="t-field t-select" [(ngModel)]="changedExamCode" (ngModelChange)="setExamCode(pat)">
                                    <option *ngFor="let name of getTodayListExamTypes()" [value]="name">{{name}}</option>
                                </select>
                            </span>
                            <span class="l-td-m patient-item-cell patient-name-first" *ngIf="loginService.separatedClinic && (loginService.isAdmin || loginService.userType == 'secretary')">
                                {{loginService.getDocByUID(pat.UID)}}
                            </span>
                            <span class="l-td-m patient-item-cell patient-name-first" *ngIf="! loginService.ishospital && ! loginService.isCardio && !loginService.isGastro" (click)="setAWL(pat);selectedPatient=pat">
                                {{pat.ExamLMP ? 'LMP: '+ (pat.ExamLMP | date: 'd.M.yyyy'):''}}  {{GaArray ? 'GA: ' + GaArray[i]: '-1w -1d'}}
                            </span>
                            <span class="l-td-m patient-item-cell patient-name-first" (click)="setAWL(pat);selectedPatient=pat">
                                {{getStatus(pat.Status)}}
                            </span>
                        </div>			
        
                    </div>
                    <a
                      *ngIf="!loginService.hasPremission('NoExams')"
                      [state]="{ data: pat }"
                      routerLink="/exams"
                      (click)="
                        patservice.setPat(pat); setPatAwlid(pat); exServ.checkSimilarId = true
                        "
                      class="l-td-m patient-item-exit"
                      ></a>
                </div>

            @if (patList && patList.length === 0 && !isAWL) {
                <p style="padding: 2rem; text-align: center;">{{ 'GUI.Patients.empty.patients' | translate }}</p>
            } @else if (patList && !isAWL) {
                <app-pagination-controls [total]="totalResults" [page]="currentPage" [totalPages]="totalPages" (prev)="prevPatPage()" (next)="nextPatPage()"></app-pagination-controls>
            <div class="l-flex patient-item" *ngFor="let pat of patList">
    
                <button class="w100 patient-item-link" (click)="selectedPatient=pat" matTooltip="Open Patient Record">
    
                    <div class="l-table h100">
    
                        <span class="l-td-m patient-item-cell patient-id">
                            {{pat.IsID?'ID' : 'Passport'}}: <strong>{{pat.ID}}</strong>
                        </span>
    
                        <span class="l-td-m patient-item-cell patient-name-first">
                            {{pat.First}}
                        </span>
    
                        <span class="l-td-m patient-item-cell patient-name-last">
                            {{pat.Last}}
                        </span>
                        <span class="l-td-m patient-item-cell patient-name-first" *ngIf="loginService.separatedClinic && (loginService.isAdmin || loginService.userType == 'secretary')">
                            {{loginService.getDocByUID(pat.UID)}}
                        </span>
    
                    </div>			
    
                </button>
                <a
                  *ngIf="!loginService.hasPremission('NoExams')"
                  [state]="{ data: pat }"
                  routerLink="/exams"
                  (click)="patservice.setPat(pat); exServ.checkSimilarId = true"
                  matTooltip="Open Patient History"
                  class="l-td-m patient-item-exit"
                ></a>
            </div>
            @if (patList.length >= pageSize && totalPages > 1) {
                <app-pagination-controls [total]="totalResults" [page]="currentPage" [totalPages]="totalPages" (prev)="prevPatPage()" (next)="nextPatPage()"></app-pagination-controls>
            }
            }
            }
           <!-- ================ Reports (Start) ================ -->
            @if (isReportsLoading) {
                <div class="list-spinner-wrap" [class.is-leaving]="isReportsFading">
                    <img src="../../assets/images/Wedges.svg" alt="Loading..." class="list-spinner-img" />
                </div>
            }
            
            @if (!isReportsLoading) {
            <div>
                @if (exServ.searchReport) {

                <div style="margin: 10px;padding: 10px;border-radius: 10px;border: 1px solid grey;">
                    <div class="w100" style="display: flex; justify-content: space-evenly;flex-direction: row-reverse;">
                        <span style="margin: 0 5px;">
                            <label style="margin: 0 5px;font-weight: 700;">חיפוש לפי</label>
                            <span style="margin: 0 5px;" *ngIf="exServ.searchReport.type == 'Macabifin'">דו"ח מכבי פיננסי
                                <select class="t-field t-select" [(ngModel)]="macabiMissing" (change)="examSearch('Macabifin','Macabi')">
                                    <option [ngValue]="false">פרטים מלאים</option>
                                    <option value="codes" *ngIf="loginService.hasPremission('Pneumology')">חסר קוד טיפול</option>
                                    <option value="refnum"> חסר פרטים {{loginService.hasPremission('Pneumology')? 'אחרים':''}}</option>
                                     <option value="notsigned" *ngIf="loginService.hasPremission('Pneumology')"> לא נחתם</option>
                                </select>
                            </span>
                            <span style="margin: 0 5px;" *ngIf="exServ.searchReport.type == 'Macabi'">בדיקות שנשלחו למכבי</span>
                            <span style="margin: 0 5px;" *ngIf="exServ.searchReport.type == 'Refferelnum'">מס' הפניה חסר</span>
                            <span style="margin: 0 5px;" *ngIf="exServ.searchReport.type == 'NotSigned'">בדיקות לא חתומות</span>
                            <span style="margin: 0 5px;" *ngIf="exServ.searchReport.type == 'HMO'">{{getHMO(exServ.searchReport.hmo)}}</span>
                        </span>
                        <span style="margin: 0 5px;display: flex;flex-direction: row-reverse;"> 
                            <label style="margin: 0 5px;font-weight: 700;">תאריכים</label> 
                            <div style="display: flex;flex-direction: row">
                                <span> {{exServ.searchReport.start | date: "dd/MM/yyyy"}} </span>
                                <label>-</label>
                                <span >{{exServ.searchReport.end | date: "dd/MM/yyyy"}}</span>
                            </div>
                        </span>
                    </div>
                </div>
                 }

                @if (examList && examList.length === 0) {
                <p style="padding: 2rem; text-align: center;">{{ (exServ.searchReport ? 'GUI.Patients.empty.reports' : 'GUI.Patients.empty.exams') | translate }}</p>
                }

                 @if (! loginService.hasPremission('NoExams')) {
                    <div *ngFor="let name of examNames" style="margin: 1em 0;">
                        <div class="l-flex" *ngIf="filterExams(examList, name).length > 0" style="display: flex;justify-content: space-between;">
                            <span style="font-size: x-large;"><strong>{{name}}</strong></span>
                            <div class="l-flex r-hmos" >
                                <span  [ngClass]="(examList && filterExams(examList, name, 'Leumit').length >= loginService.limits[getDbName(name, 'Leumit')]) ? 'error': '' "  *ngIf="loginService.limits&&loginService.limits[getDbName(name, 'Leumit')]" style="font-size: x-large;"><strong>Leumit: {{filterExams(examList, name, 'Leumit').length}}/{{loginService.limits[getDbName(name, 'Leumit')]}}</strong></span>
                                <span  [ngClass]="(examList && filterExams(examList, name, 'Macabi').length >= loginService.limits[getDbName(name, 'Macabi')]) ? 'error': '' " *ngIf="loginService.limits&&loginService.limits[getDbName(name, 'Macabi')]" style="font-size: x-large;"><strong>Macabi: {{filterExams(examList, name, 'Macabi').length}}/{{loginService.limits[getDbName(name, 'Macabi')]}}</strong></span>
                                <span  [ngClass]="(examList && filterExams(examList, name, 'Meuhedet').length >= loginService.limits[getDbName(name, 'Meuhedet')]) ? 'error': '' " *ngIf="loginService.limits&&loginService.limits[getDbName(name, 'Meuhedet')]" style="font-size: x-large;"><strong>Meuhedet: {{filterExams(examList, name, 'Meuhedet').length}}/{{loginService.limits[getDbName(name, 'Meuhedet')]}}</strong></span>
                                <span  [ngClass]="(examList && filterExams(examList, name, 'Clalit').length >=loginService.limits[getDbName(name, 'Clalit')]) ? 'error': '' " *ngIf="loginService.limits&&loginService.limits[getDbName(name, 'Clalit')]" style="font-size: x-large;"><strong>Clalit: {{filterExams(examList, name, 'Clalit').length}}/{{loginService.limits[getDbName(name, 'Clalit')]}}</strong></span>
        
        
                            </div>
                        </div>
                        <div class="l-flex patient-item" *ngFor="let exam of filterExams(examList, name)">
                            <button class="w100 patient-item-link" (click)="goPatient(exam.PID)" matTooltip="Click to View Patient History">
                
                                <div class="l-table h100">
                                    <span class="l-td-m patient-item-cell patient-name-first">
                                        Exam Time: <strong>{{exam.CreationTime | date:"dd/MM/yyyy h:mm a"}}</strong>
                                    </span>
                                    <span class="l-td-m patient-item-cell patient-id">
                                        ID: <strong>{{exam.ID}}</strong>
                                    </span>
                
                                    <span class="l-td-m patient-item-cell patient-id">
                                        Name: {{exam.First}}  {{exam.Last}}
                                    </span>
                                  
                                    <span class="l-td-m patient-item-cell patient-name-first">
                                        Exam Type: <strong>{{exam.ExamType}}
                                        @if(exam.Changed) {
                                        <span>
                                            ({{exam.ChangedExamTitle}})
                                        </span>
                                        }
                            
                                    </strong>
                                    </span>
                                    <!-- Macabi codes and prices information -->
                                     @if(exam.HMOExamCode && getMacabiCodesPricesString(exam).codesDisplay) {
                                        <span class="l-td-m patient-item-cell patient-name-first">
                                            <strong>Codes:</strong> {{ getMacabiCodesPricesString(exam).codesDisplay }}
                                        </span>
                                     }
                                     @if (exam.HMOExamCode && getMacabiCodesPricesString(exam).totalPrice) {
                                        <span class="l-td-m patient-item-cell patient-name-first">
                                            <strong>Total:</strong> {{ getMacabiCodesPricesString(exam).totalPrice }}
                                        </span>
                                     }
                                </div>            
                
                            </button>
                            <a class="l-td-m patient-item-exit" [ngClass]="getLocked(exam)" (click)="goExam(exam)" [matTooltip]="(getLocked(exam) === 'locked' ) ? 'Locked By: ' +exam.LockedBy : 'View Exam'"></a>


                        </div>
                    </div>
                 }
            </div>
            }
            <!-- ================ Reports (End) ================ -->

            <div  *ngIf="!loginService.isCardio || loginService.hasPremission('NoExams')">
                @if (examList && examList.length === 0 && !isReportsLoading) {
                <p style="padding: 2rem; text-align: center;">{{ (exServ.searchReport ? 'GUI.Patients.empty.reports' : 'GUI.Patients.empty.exams') | translate }}</p>
                }
                <div class="l-flex patient-item" *ngFor="let exam of examList">
        
                    <button class="w100 patient-item-link" (click)="goPatient(exam.PID)" matTooltip="Click to View Patient History">
        
                        <div class="l-table h100">
                            <span class="l-td-m patient-item-cell patient-name-first">
                                Exam Time: <strong>{{exam.CreationTime | date:"dd/MM/yyyy h:mm a"}}</strong>
                            </span>
                            <span class="l-td-m patient-item-cell patient-id">
                                ID: <strong>{{exam.ID}}</strong>
                            </span>
        
                            <span class="l-td-m patient-item-cell patient-id">
                                Name: {{exam.First}}  {{exam.Last}}
                            </span>
        
                            <span class="l-td-m patient-item-cell patient-name-first">
                                Deductible: <strong>{{exam.PatPayment}} <span *ngIf="exam.CollectAtClinic && exam.PatPayment > 0">(To Collect)</span></strong>
                            </span>
        
                        </div>			
        
                    </button>
                    
        
                </div>
        </div>



    
        </main>
        
        <!-- ========================== main sidebar (start) ========================== -->
        
        <aside class="l-sidebar l-flex l-column">
            
            <img class="off-mobile sidebar-logo logo-3d-effect" src="assets/icons/logo.svg" alt="Artisan Sonics" />
    
            <!-- user panel (start) -->
            <div class="userPanel">
                
                <i class="userPanel-icon icon-female">
        
                </i>

                <div class="userPanel-userName" >
                   Patient Search
                </div>
                
    
                <div class="search-patient">
    
                    <div class="search-patient-field">
                        <div class="t-field l-flex t-twin-fieldset">
                            <label>
                                <input type="radio" name="idp" [(ngModel)]="idp" [value]="1" class="custom-check customInput" aria-labelledby="pregnancy_popup-sex">
                                <i class="customInput-display"></i>
                                <span class="t-field-desc">
                                    ID
                                </span>
                            </label>
                            <label>
                                <input type="radio" name="idp" [value]="0" class="custom-check customInput" aria-labelledby="pregnancy_popup-sex">
                                <i class="customInput-display"></i>
                                <span class="t-field-desc">
                                    Passport
                                </span>
                            </label>
                        </div>
                    </div>
    
                    <div class="t-validation-wrap">
                        <input type="text" class="search-patient-field idnumber" [ngClass]="invalidi" placeholder="ID Number" [(ngModel)]="id" (keyup)="invalidi='';trysearch()" pattern="[A-Za-z0–9\-]+">
                        <div class="t-validation-message">
                            <span>Invalid ID Number</span>
                        </div>
                    </div>
    
                    <div class="t-validation-wrap">
                        <input type="text" class="search-patient-field" placeholder="First Name" [ngClass]="invalidf" [(ngModel)]="first" (keyup)="invalidf='';trysearch()">
                        <div class="t-validation-message">
                            <span>Please fill in first name</span>
                        </div>
                    </div>
    
                    <div class="t-validation-wrap">
                        <input type="text" class="search-patient-field" placeholder="Last Name" [ngClass]="invalidl" [(ngModel)]="last" (keyup)="invalidl='';trysearch()">
                        <div class="t-validation-message">
                            <span>Please fill in last name</span>
                        </div>
                    </div>
                    
                    <div class="t-validation-wrap">
                        <input type="tel" class="search-patient-field" placeholder="Phone" [(ngModel)]="phone">
                        <div class="t-validation-message">
                            <span>Invlid phone</span>
                        </div>
                    </div>
    
                    <div class="l-flex l-flex-w t-fieldmargin search-btns">
                        <div class="w100" *ngIf="loginService.showAWL()">
                            <button class="search-btn" (click)="AWL();isReports=false" matTooltip="Artisan Worklist">TodayList</button>
                        </div>
                        <div class="w50">
                            <button class="search-btn" [disabled]="isSearchButtonDisabled" (click)="searchNow();isReports=false" matTooltip="Search Patient">Search</button>
                        </div>
                        <div class="w50">
                            <button class="search-btn" (click)="clear()" [ngClass]="id.length > 0 || last.length>0 || first.length > 0 || phone.length > 0 ? '' : 'search-btn--clear'" matTooltip="Clear Search Fields">Clear</button>
                        </div>
                        <div class="w100">
                            <button class="search-btn search-btn--newPatient" (click)="addPatient();isReports=false" matTooltip="Open New Patient">New Patient</button>
                        </div>
                        <div class="w100"  *ngIf="! loginService.hasPremission('NoExams')">
                            <button class="search-btn" matTooltip="Search Exams" (click)="openEsearch=true;isReports=false">Search Exams</button>
                        </div>
                        <div class="w100" *ngIf="loginService.userType =='secretary' || loginService.userType == 'doctor'">
                            <button class="search-btn" matTooltip="Reports"  (click)="openEsearch=true;isReports=true">Reports</button>
                        </div>
                        <div class="w100" *ngIf="loginService.hasPremission('MacabiFillPatient')">
                            <button class="search-btn" matTooltip="Maccabi Credit check (WITHOUT card)"  (click)="getTZ()">Maccabi W/O Card</button>
                        </div>
                        <div class="w100">
                            <button class="search-btn" matTooltip="{{'GUI.Tooltips.Go to appointments' | translate}}" matTooltipPosition="after"
                                *ngIf="loginService.hasPremission('Appointments')" (click)="redirectAdministration('appointments')">
                                Appointments
                            </button>
                        </div>
                        <div class="w100">
                            <button class="search-btn" matTooltip="{{'GUI.Tooltips.Go to billing' | translate}}" matTooltipPosition="after"
                                *ngIf="loginService.hasPremission('Billings')" (click)="redirectAdministration('billing')">
                                Billings
                            </button>
                        </div>
                        <div class="w100">
                            <button class="search-btn" matTooltip="{{'GUI.Tooltips.Go to financial reports' | translate}}" matTooltipPosition="after"
                                *ngIf="loginService.hasPremission('FinancialReports')" (click)="redirectAdministration('financial')">
                                Financial Reports
                            </button>
                        </div>
                        <div class="w100">
                            <button class="search-btn" *ngIf="this.hasMessagingApp" (click)="openMsgApp()"
                            [matBadge]="messageCount$ | async"
                            [matBadgeHidden]="(messageCount$ | async) === 0"
                            matBadgeColor="warn"
                            matBadgePosition="above after"
                            aria-label="Notifications for new messages" matTooltipPosition="after" [matTooltip]="'Open Messaging App'">
                                Messages <img src="../../assets/icons/messages.svg" style="height: 22px;width: 22px;">
                                <mat-icon *ngIf="(msgAppAccessService.state$ | async) === 'minimized'" class="open-indicator-icon">aspect_ratio</mat-icon>
                            </button>
                        </div>
    
                    </div>
    
                </div>

    
                <div class="search-help">
                    Need help?
                    <button class="open-help" (click)="showhelp=true">Click Here</button>
                </div>
                
            </div>
            <!-- user panel (end) -->
    
            <!-- main nav (start) -->
            <nav class="mainNav l-fg1 scroller">
    
            </nav>
            <!-- main nav (end) -->
            <app-docpanel></app-docpanel>
            
    
        </aside>
    
        <!-- ========================== main sidebar (end) ========================== -->
        
        <app-bottombar></app-bottombar>
    
        </div><!-- end wrapper -->
    
    
        <!-- ===================================== POPUP : HELP (START) =============================================== -->
    
        <div class="t-popup popup-help" *ngIf="showhelp">
    
            <div class="t-popup-close"></div>
            
            <div class="t-popup-frame">
                <div class="t-popup-body">
    
                    <button class="t-btn-popup-close" aria-label="close popup" (click)="showhelp=false"></button>
    
                    <h2>
                        Help
                    </h2>
    
                    <section class="part-help">
    
                        <h3>
                            Search
                        </h3>
    
                        It is a long established fact that a reader will be distracted by the readable content
                        of a page when looking at its layout. The point of using Lorem Ipsum is that it has a
                        more-or-less normal distribution of letters, as opposed to using 'Content here,
                        content here', making it look like readable English. Many desktop publishing packages
                        and web page editors now use Lorem Ipsum as their default model text, and a search for
                        'lorem ipsum' will uncover many web sites still in their infancy. Various versions have 
                        evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).
    
    
                    </section>
    
                    
                    
                </div>
            </div>
        </div>
        <div class="t-popup popup-help" *ngIf="carderror" style="display: inherit">
    
            <div class="t-popup-close"></div>
            
            <div class="t-popup-frame">
                <div class="t-popup-body">
    
                    <button class="t-btn-popup-close" aria-label="close popup" (click)="carderror=null"></button>
    
                    <h2 style="direction: rtl; margin-right: 3em;" *ngIf="! loginService.hasPremission('MacabiFillPatient')">
                        מטופל עם ת.ז. {{carderror}} לא נמצאה ברשימת המוזמנים להיום.
                    </h2>
                    <h2 style="direction: rtl; margin-right: 3em;" *ngIf="loginService.hasPremission('MacabiFillPatient')">
                       {{carderror}}
                    </h2>
    
                    <section class="part-help">
    
                        <h3 style="direction:rtl">
                            נא לבדוק נכונות המספר ולנסות שוב
                        </h3> 
                    </section>                 
                </div>
            </div>
        </div>

       <!-- <div class="t-popup popup-help" *ngIf="tocopy" style="display: inherit">
    
            <div class="t-popup-close"></div>
            
            <div class="t-popup-frame">
                <div class="t-popup-body">
    
                    <button class="t-btn-popup-close" aria-label="close popup" (click)="toreassign=null;AWL()"></button>
    
                    <h2>
                        Warning!
                    </h2>
    
                    <section class="part-help">
    
                        <h3>
                            This will remove {{toreassign.First + ' ' + toreassign.Last}} from {{loginService.getDocByUID(toreassign.UID)}} and make her a patient of {{loginService.getDocByUID(toreassign.nUID)}}.
                        </h3>
                        <button (click)="reassign()">OK</button>    
                        <button style="float:right" (click)="toreassign=null;AWL()">Cancel</button> 
                    </section>                 
                </div>
            </div>
        </div>--->
        <img *ngIf="macSearch" src="../../assets/images/Wedges.svg"
                        style='z-index:0;margin-left: auto;margin-right:auto;position: absolute;left: 0; right: 0;top: 40vh'>

        <app-informconcent *ngIf="inform" (closed)="closCalForm($event)" [pat]="exServ.patServ.getPat()" [form]="concentForm"></app-informconcent>

        <app-loginbox *ngIf="showLogin" (closed)="showLogin=false" (viewonly)="viewonly()" [isnew]="false"></app-loginbox>
        <app-patdetails *ngIf="selectedPatient && ! typeForm" [pat]="selectedPatient" [awl]="chosenAWL" [awlExam]="awlExamType" [awlTime]="awlTime" [awlLMP]="awlLMP" [awlComment]="awlComment" [openWAWL]="loginService.barcodeScan" (closed)="onClosed($event)" (showpay)="paymentNoCard()"></app-patdetails>
        <app-payment *ngIf="showpayment" [tz]="showpayment" [idtype]="idcode" [awlid]="selectedPatient.AWLID" [exp]="expcode" (closed)="showpayment=null"></app-payment>
        <app-searchbox *ngIf="openEsearch" (closed)="searchClosed($event)" [isReports]="isReports" [reportstype]="reportName" [hmostype]="hmostype" [isGastro]="loginService.isGastro" [startdate]="fromd" [enddate]="tod" [examtype]="examMode" [exams]="examVals"></app-searchbox>
        <app-commerror></app-commerror> 
        <app-printopts *ngIf="showprint" (closed)="showprint=false" [showopts]="showprintopts" [stats]="true" [isReport]="true" [type]="reportName" [startdate]="fromd" [enddate]="tod" [hmostype]="hmostype">
        </app-printopts>
        <app-send-questionnaire *ngIf="showSendQuestionnaire" [patient]="sendQuestionnairePatient" (closed)="showSendQuestionnaire=false; selectedPatient=null"></app-send-questionnaire>
    </div>
    
